export const NOTIFICATION_PAGE_QUERY_PAGE_SIZE = 50;
